import { Pass } from "./Pass.js";

/**
 * A pass that disables the stencil mask.
 */

export class ClearMaskPass extends Pass {

	/**
	 * Constructs a new clear mask pass.
	 */

	constructor() {

		super(null, null, null);

		/**
		 * The name of this pass.
		 */

		this.name = "ClearMaskPass";

	}

	/**
	 * Disables the stencil test.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 */

	render(renderer) {

		renderer.state.buffers.stencil.setTest(false);

	}

}



//////////////////
// WEBPACK FOOTER
// ./~/postprocessing/src/passes/ClearMaskPass.js
// module id = 60
// module chunks = 0